import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

const err = (e) => toast.error(formatApiError(e.response?.data?.detail));

export default function AdminRedirects() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ eski: "", yeni: "" });
  const load = () => api.get("/admin/redirects").then((r) => setItems(r.data.items)).catch(err);
  useEffect(() => { load(); }, []);
  const add = () => api.post("/admin/redirects", f).then(() => { toast.success("Yönlendirme eklendi"); setF({ eski: "", yeni: "" }); load(); }).catch(err);
  const del = (r) => window.confirm(`${r.eski} yönlendirmesi silinsin mi?`) && api.delete("/admin/redirects", { params: { eski: r.eski } }).then(load).catch(err);
  return (
    <div className="max-w-4xl" data-testid="admin-redirects-page">
      <h1 className="font-head text-2xl font-bold text-slate-900 mb-1">URL Yönlendirmeleri</h1>
      <p className="text-sm text-slate-500 mb-4">Ürün veya kategori URL'si değiştiğinde eski adres otomatik eklenir. Elle de tanımlayabilirsiniz.</p>
      <div className="flex gap-2 flex-wrap mb-4">
        <Input value={f.eski} onChange={(e) => setF({ ...f, eski: e.target.value })} placeholder="Eski adres (/urun/eski-adres)" className="flex-1 min-w-[220px]" data-testid="redirect-old" />
        <Input value={f.yeni} onChange={(e) => setF({ ...f, yeni: e.target.value })} placeholder="Yeni adres (/urun/yeni-adres)" className="flex-1 min-w-[220px]" data-testid="redirect-new" />
        <Button onClick={add} className="bg-teal-600 hover:bg-teal-700" data-testid="redirect-add">Ekle</Button>
      </div>
      <div className="bg-white border rounded-xl overflow-x-auto"><table className="w-full text-sm" data-testid="redirects-table">
        <thead><tr className="text-left text-xs text-slate-500 border-b"><th className="p-2">Eski</th><th className="p-2">Yeni</th><th className="p-2">Oluşturan</th><th></th></tr></thead>
        <tbody>{items.map((r) => <tr key={r.eski} className="border-b last:border-0"><td className="p-2 break-all">{r.eski}</td><td className="p-2 break-all">{r.yeni}</td><td className="p-2 text-xs">{r.olusturan} · {(r.at || "").slice(0, 10)}</td>
          <td className="p-2"><button onClick={() => del(r)} className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button></td></tr>)}
          {!items.length && <tr><td colSpan={4} className="p-4 text-center text-slate-400">Yönlendirme yok</td></tr>}</tbody></table></div>
    </div>
  );
}
